/* import __COLOCATED_TEMPLATE__ from './color-picker.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  classNames: "colors-container",

  actions: {
    selectColor(color) {
      this.set("value", color);
    },
  },
});
